(function () {
    'use strict';

    a3_cabin_reports.controller('RequestsCtrl', RequestsCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name RequestsCtrl
    * @description 
    *   Shows Roster Requests
    * @ngInject
    */
    function RequestsCtrl($scope, RequestFactory, $timeout, $uibModal, LogService) {

        $scope.state = 'requests';

        $scope.ancillaries = null;
        $scope.activeRequests = null;
        $scope.isAvailableFeature = false;
        $scope.hasAncillaries = false; //for testing true || live false !;
        $scope.showActiveRequests = false; //for testing true || live false !;
        $scope.contentToShow = "loading";
        window.addEventListener('online', function (e) { $timeout(checkConnectionStatus()); });
        $scope.init = checkConnectionStatus();
        $scope.closeAlert = closeAlert;
        $scope.openRequest = openRequest;
        $scope.page = null;
        $scope.closeForm = closeForm;
        $scope.newForm = {};
        $scope.submitRequest = submitRequest;
        $scope.submitForcedRequest = submitForcedRequest;
        $scope.forceSubmitRequest = forceSubmitRequest;
        $scope.getActiveRequests = getActiveRequests;
        $scope.updateFromValue = updateFromValue;
        $scope.dutyCode = "";
        $scope.showHelp = showHelp;
        $scope.instruction = '';
        $scope.flightRequestType = null;
        $scope.setFlightRequestType  = setFlightRequestType;
        $scope.resetStart = resetStart;
        $scope.resetEnd = resetEnd;
        //ground duties request types:
        $scope.singleDayRequestType = true;
        $scope.toggleGroundRequestType = toggleGroundRequestType;
        $scope.updateFromValueGD = updateFromValueGD;
        $scope.submitLoader = false;

        $scope.toggleViewMode = toggleViewMode;
        $scope.getPastRequests = getPastRequests;

        $scope.isHistoryView = false;
        $scope.showPastRequests = false;
        $scope.hasDutyPreferencesSettings = false;

        //------------ Request List --------------
        // $scope.showMobileRequestListCriteria = true;
        $scope.filterRequest = filterRequest;
        $scope.getRequestBorderStyle = getRequestBorderStyle;
        $scope.getRejectReason = getRejectReason;
        $scope.toggle = {
            Accepted: true,
            Rejected: true,
            Pending: true,
            FinalAccepted: true
        }

        $scope.submissionDeadline = RequestFactory.getSubmissionDeadlineDateFromStorage();
        $scope.daysDiff = daysDiff;

        /**
         * Calculates days left
         * @memberof CalendarCtrl
         * @return {string} usage
         */
        function daysDiff(date) {
            var today = moment().startOf('day');
            var expiryDate = moment(date);

            return expiryDate.diff(today, 'days');
        }

        /**
         * Get ancillaries for the forms
         * @memberof RequestsCtrl  
         */
        function getAncillaries() {
            RequestFactory.getAncillaries()
                .then(response => {
                    $scope.contentToShow = "";
                    if (response.success) {
                        if (response.data) {
                            $scope.ancillaries = response.data;

                            // Request types based on crew member's qualification group(s) settings
                            $scope.hasDutyPreferencesSettings = $scope.ancillaries.ShiftTimeRequests && $scope.ancillaries.ShiftTimeRequests.length > 0;
                            $scope.hasOtherRequestsSettings = $scope.ancillaries.HasOtherRequestsSettings;
                            $scope.hasFlightRequestsByFlightNoSettings = $scope.ancillaries.HasFlightRequestsByFlightNoSettings;
                            $scope.hasFlightRequestsByTimeRangesSettings = $scope.ancillaries.HasFlightRequestsByTimeRangesSettings;

                            $scope.flightOrDutyPreferenceIsVisible = ($scope.ancillaries.FlightDutyCategories && $scope.ancillaries.FlightDutyCategories.length > 0) 
                                                                   || $scope.hasFlightRequestsByFlightNoSettings
                                                                   || $scope.hasFlightRequestsByTimeRangesSettings;

                            // Create Your Request Menu: visibility option                                       
                            $scope.isAvailableFeature = $scope.ancillaries.DutyCodes && $scope.ancillaries.DutyCodes.length > 0       
                                                     || $scope.flightOrDutyPreferenceIsVisible                                             
                                                     || $scope.hasDutyPreferencesSettings 
                                                     || $scope.hasOtherRequestsSettings;
                                                                       
                            $scope.hasAncillaries = true;

                            $scope.newForm.singleDate = $scope.ancillaries.RosterPeriodFrom;
                            $scope.newForm.dateFrom = $scope.ancillaries.RosterPeriodFrom;
                            $scope.newForm.dateTo = $scope.ancillaries.RosterPeriodTo;

                            //groundDuties
                            $scope.newForm.dutyDateFrom = $scope.ancillaries.RosterPeriodFrom;
                            $scope.newForm.dutyDateTo = $scope.ancillaries.RosterPeriodFrom;

                            $scope.optionsSingle = {
                                minDate: $scope.ancillaries.RosterPeriodFrom,
                                initDate: $scope.ancillaries.RosterPeriodFrom
                            }
                            $scope.optionsFrom = {
                                minDate: $scope.ancillaries.RosterPeriodFrom,
                                initDate: $scope.ancillaries.RosterPeriodFrom
                            }
                            $scope.optionsTo = {
                                minDate: $scope.ancillaries.RosterPeriodFrom,
                                initDate: $scope.ancillaries.RosterPeriodTo
                            }
                            $scope.optionsDutyDateTo = {
                                minDate: $scope.ancillaries.RosterPeriodFrom,
                                initDate: $scope.ancillaries.RosterPeriodFrom
                            }
                     
                            // Fetch flight category types for the dropdown list
                            $scope.ancillaries.flightCategoryTypes = []; 

                            if($scope.hasFlightRequestsByFlightNoSettings) {
                                $scope.ancillaries.flightCategoryTypes.push({Value: 1, Text:'Flight No.'});
                            }

                            if($scope.ancillaries.FlightDutyCategories && $scope.ancillaries.FlightDutyCategories.length > 0) {
                                $scope.ancillaries.flightCategoryTypes.push({Value: 2, Text:'Flight Duty Preference'});
                            }
                            
                            if($scope.hasFlightRequestsByTimeRangesSettings) {
                                $scope.ancillaries.flightCategoryTypes.push({Value: 3, Text:'Flight Duty Preference with time limit'});
                            }
                        }
                        else {
                            //TODO:: fix message
                            showError("Ancillaries not found.");
                        }
                    }
                    else {
                        showError(response.message);
                    }

                })
        }

        /**
         * Get Active Requests
         * @memberof RequestsCtrl  
         */
        function getActiveRequests() {
            RequestFactory.getActiveRequests()
                .then(response => {
                    if (response.success) {
                        if (response.data) {
                            $scope.activeRequests = response.data;
                            $scope.instruction = response.data.QualificationGroupInstruction;
                            $scope.showActiveRequests = response.data.FlightRequests.length || response.data.GroundDutyRequests.length || response.data.OtherRequests.length ||
                                response.data.OvernightsRequests.length || response.data.ShiftTimeRequests.length;
                        } else {
                            showError("Something went wrong while fetching your roster requests.");
                        }
                    }
                    else {
                        showError(response.message);
                    }

                });
        }

        function getPastRequests() {
            RequestFactory.getPastRequests()
                .then(response => {
                    if (response.success) {
                        if (response.data) {
                            $scope.pastRequests = response.data;
                            $scope.isHistoryView = true;
                            $scope.instruction = response.data.QualificationGroupInstruction;
                            $scope.showPastRequests = response.data.FlightRequests.length > 0 || response.data.GroundDutyRequests.length > 0|| response.data.OtherRequests.length > 0||
                                response.data.OvernightsRequests.length >0 || response.data.ShiftTimeRequests.length > 0; 
                        } else {
                            showError("Something went wrong while fetching your roster requests.");
                        }
                    }
                    else {
                        showError(response.message);
                    }

                });
        }

        /**
         * Displays the error message
         * @memberof RequestsCtrl  
         * @param {string} message message to display
         */
        function showError(message) {
            $scope.contentToShow = "error";
            $scope.errorMessage = message;
        }

        /**
         * Displays the success message
         * @memberof RequestsCtrl
         */
        function showSuccess(message) {
            $scope.contentToShow = "success";
            $scope.successMessage = message;
        }

        function closeAlert() {
            $scope.contentToShow = "";
        }


        /**
         * Checks if the client is online or offline 
         * @memberof RequestsCtrl  
         */
        function checkConnectionStatus() {
            var isOnline = window.navigator.onLine;
            if (isOnline) {
                getAncillaries();
                getActiveRequests();
            }
            else {
                showError("Please check your internet connection!");
            }
        }

        /**
         * Date to always greater than date from
         * @memberof RequestsCtrl  
         */
        function updateFromValue(dateFrom) {
            $scope.newForm.dateTo = dateFrom;
            $scope.optionsTo = {
                minDate: dateFrom
            }
        }

        /**
         * Date picker limits for the ground duty requests
         * @memberof RequestsCtrl  
        */
           function updateFromValueGD(dateFrom, limitation) {
            $scope.newForm.dateTo = dateFrom;

            $scope.optionsDutyDateTo = {
                initDate: dateFrom,
                minDate: dateFrom,
                maxDate: dateFrom.AddDays(limitation - 1)
            }
        }

        function setFlightRequestType(){
            //[{Value: 1, Text:'Flight No.'}, {Value: 2, Text:'Flight Duty Preference'}, {Value: 3, Text:'Time Limitations'}]
            //$scope.flightRequestType = parseInt($scope.newForm.flightRequestType, 10);
            if ($scope.newForm.flightRequestType != null) {
                $scope.flightRequestType = parseInt($scope.newForm.flightRequestType, 10);
            } else {
                $scope.flightRequestType = null; 
            }
        }
 
        function resetStart(){
			$scope.newForm.afterTime = null;
		}
		function resetEnd(){
			$scope.newForm.beforeTime = null;
		}


        function toggleGroundRequestType(){
            if($scope.newForm.groundRequestType == 'continuous'){
                $scope.singleDayRequestType = false;
            }else{
                $scope.singleDayRequestType = true;
            }
        }

        /**
         * Opens the request type selected
         * @memberof RequestsCtrl
         */
        function openRequest(inputObject, dutyCode) {
            clearForms();
            if (inputObject == "Flight") {
                $scope.page = 'Flight';
               // Preselect "Flight Duty Preference" only when Flight page is opened
            if ($scope.ancillaries.flightCategoryTypes && $scope.ancillaries.flightCategoryTypes.length > 0) {
                $scope.newForm.flightRequestType = "2";
                $scope.flightRequestType = 2;
            }
            }
            else if (inputObject == "Duty Preference") {
                $scope.page = 'Duty Preference';
            }
            else if (inputObject == "Overnight") {
                $scope.page = 'Overnight'
            }
            else if (inputObject == "Other") {
                $scope.page = 'Other';
            }
            else if (inputObject == "Ground Duty") {
                $scope.page = 'Ground Duty';
                $scope.dutyCode = dutyCode;
            }
        }

        /**
         * Submits the request form
         * @memberof RequestsCtrl
         */
        function submitRequest(inputObject, dutyCode) {
            $scope.submitLoader = true;
            if (inputObject == "Flight" && $scope.flightRequestType != null) {
                var rosterRequest = {
                    FlightDate: $scope.newForm.singleDate.toString("yyyy/MM/dd"),
                    ReasonId: $scope.newForm.requestReason.Id,
                    Comments: $scope.newForm.comments,
                    Type: $scope.flightRequestType,
                    IsForced: false
                };
                if($scope.flightRequestType == 1){
                    rosterRequest.FlightNo = $scope.newForm.flightNo;
                }else if($scope.flightRequestType == 2){
                    rosterRequest.FlightDutyCategoryId = $scope.newForm.flightDuty.Id;
                }
                else if($scope.flightRequestType == 3){
                    rosterRequest.afterTime = ($scope.newForm.afterTime !== null && $scope.newForm.afterTime !== undefined) ? moment($scope.newForm.afterTime) : null;
                    rosterRequest.beforeTime = ($scope.newForm.beforeTime !== null && $scope.newForm.beforeTime !== undefined) ? moment($scope.newForm.beforeTime) : null;
                }
                RequestFactory.sendFlightRequest(rosterRequest)
                    .then(response => {
                        handleSubmitResponse(response, rosterRequest);
                    });
            }
            else if (inputObject == "Ground Duty") {
                
                //validation with duty limitation
                var trimmedFrom = new Date($scope.newForm.dateFrom);
                var trimmedTo = new Date($scope.newForm.dateTo);
                var diffDays = Date.DifferenceInDays(trimmedFrom.trimTime(), trimmedTo.trimTime());
                if(diffDays > dutyCode.Limitation ){
                    //show warning message? : 
                    $scope.disableSubmit  = true;
                }

                if($scope.singleDayRequestType){
                    $scope.newForm.dateTo = $scope.newForm.dateFrom;
                }

                var rosterRequest = {
                    DutyDateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
                    DutyDateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
                    GroundDuty: dutyCode.Code,
                    ReasonId: $scope.newForm.requestReason.Id,
                    Comments: $scope.newForm.comments,
                    IsForced: false
                };

                RequestFactory.sendGroundRequest(rosterRequest)
                    .then(response => {
                        handleSubmitResponse(response, rosterRequest);
                    });
            }
            else if (inputObject == "Duty Preference") {
                var dateFrom = moment(new Date($scope.newForm.dateFrom));
                var dateTo = moment(new Date($scope.newForm.dateTo));

                // Check if the request period is less than one month
                var duration = dateTo.diff(dateFrom, 'days');
                if(duration < 29){
                    var title = "<strong>Warning!</strong>";
                    var message = "<strong>Please select a period of at least one month. Requests shorter than one month cannot be processed. <br>Thank you for helping us create a more balanced schedule!</strong><br>";
                    bootbox.dialog({
                        message: message,
                        title: title,
                        buttons: {
                            cancel: {
                                label: "Close",
                                className: "btn-default",
                                callback: function () { 
                                    $scope.$apply(function () {
                                        $scope.submitLoader = false;
                                    });
                                }
                            }
                        }
                    });
                    return;
                }

                // Check if the end date exceeds January 31 of the next year
                // January 31 of the next year
                var maxEndDate = moment().endOf('year').add(1, 'months').endOf('day');
                if (dateTo.diff(maxEndDate, 'seconds') > 0) {
                    var title = "<strong>Warning!</strong>";
                    var message = "<strong>End dates beyond January 31 of the following year cannot be accepted.<br> Thank you for helping us keep schedules organized!</strong><br>";

                    bootbox.dialog({
                        message: message,
                        title: title,
                        buttons: {
                            cancel: {
                                label: "Close",
                                className: "btn-default",
                                callback: function () { 
                                    $scope.$apply(function () {
                                        $scope.submitLoader = false;
                                    });
                                }
                            }
                        }
                    });
                    return;
                }

                var rosterRequest = {
                    DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
                    DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
                    ShiftTimeId: $scope.newForm.shiftTime.Id,
                    ReasonId: $scope.newForm.requestReason.Id,
                    Comments: $scope.newForm.comments
                };
                RequestFactory.sendShiftRequest(rosterRequest)
                    .then(response => {
                        handleSubmitResponse(response);
                    });
            }
            else if (inputObject == "Overnight") {
                var rosterRequest = {
                    DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
                    DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
                    Minimum: $scope.newForm.minOvernight,
                    Maximum: $scope.newForm.maxOvernight,
                    ReasonId: $scope.newForm.requestReason.Id,
                    Comments: $scope.newForm.comments
                };
                RequestFactory.sendOvernightRequest(rosterRequest)
                    .then(response => {
                        handleSubmitResponse(response);
                    });
            }
            else if (inputObject == "Other") {
                var rosterRequest = {
                    DateFrom: $scope.newForm.dateFrom.toString("yyyy/MM/dd"),
                    DateTo: $scope.newForm.dateTo.toString("yyyy/MM/dd"),
                    ReasonId: $scope.newForm.requestReason.Id,
                    RequestFreeText: $scope.newForm.otherComments
                };
                RequestFactory.sendOtherRequest(rosterRequest)
                    .then(response => {
                        handleSubmitResponse(response);
                    });
            }
        }

        /**
         * Handles the response from the API
         * @memberof RequestsCtrl  
         * @param {object} response the response object from API
         */
        function handleSubmitResponse(response, rosterRequest) {
            var responseData = null;

            if (response.data ) {
                if (typeof response.data === 'string') {
                    try {
                        responseData = JSON.parse(response.data);
                    } catch (error) {
                        LogService.error(error, 'Failed to parse JSON');
                    }
                } else {
                    responseData = response.data;
                }
            }
            

            if (rosterRequest && response.success == true && responseData && responseData.success == false) {
                if(responseData.isOverlappingDuty){
                    //bootbox for the overlap warning
                    showOverlappingMessage();
                }else if(responseData.periodNotFound){
                    showPeriodNotFoundMessage();
                }else if($scope.page == "Ground Duty" || $scope.page == "Flight"){
                    //bootbox to confirm the forced submit - new submit on confirmed
                    forceSubmitRequest(rosterRequest, $scope.page, responseData);
                }
                else{
                    //show error message
                    showError('Request submission failed.');
                }
            } else if (response.success == false) {
                //show error message
                showError(response.message);
            } else if ( responseData.success == false) {
                //show error message
                showError('Request submission failed.');
            } else {
                //show success message
                showSuccess("Request submited successfully.");
                //refresh request list!
                getActiveRequests();
            }
            closeForm();

        }

        /**
         * Clears forms
         * @memberof RequestsCtrl
         */
        function clearForms() {
            $scope.newForm = {};
            if ($scope.ancillaries) {
                $scope.newForm.singleDate = $scope.ancillaries.RosterPeriodFrom;
                $scope.newForm.dateFrom = $scope.ancillaries.RosterPeriodFrom;
                $scope.newForm.dateTo = $scope.ancillaries.RosterPeriodTo;
                $scope.singleDayRequestType = true;
                $scope.submitLoader = false;
                $scope.disableSubmit  = false;
            }
        }

        /**
         * Closes forms
         * @memberof RequestsCtrl
         */
        function closeForm() {
            clearForms();
            $scope.page = null;
        }


        /**
         * Opens confirmation modal when request is submitted
         * @memberof RequestsCtrl
         */
        function forceSubmitRequest(rosterRequest, type, responseData) {
   
            var rosterPeriodFrom = moment.utc(responseData.rosterPeriodFrom).format('D MMM YYYY');
            var rosterPeriodTo = moment.utc(responseData.rosterPeriodTo).format('D MMM YYYY');
            var title = "<strong>Warning!</strong>";
            console.log(rosterRequest);
            var message = "";

              // Check if the limitation is reached and extra gound duties requests are prevented
            if (responseData.limitationReached && responseData.preventExtraGroundDutyRequests)  {
                // Show an error message instead of the management approval option
                message = "<strong>You cannot submit this request as you have reached the maximum allowed ground duty requests limit for this Roster Period.</strong>";
                
                bootbox.dialog({
                    message: message,
                    title: title,
                    buttons: {
                        cancel: {
                            label: "Close",
                            className: "btn-default",
                            callback: function () {
                            }
                        }
                    }
                });
                return; 
            }

              // Check if the limitation is reached and extra flight requests are prevented
              if (responseData.limitationReached && responseData.preventExtraFlightRequests) {
                // Show an error message instead of the management approval option
                message = "<strong>You cannot submit this request as you have reached the maximum allowed flight requests limit for this Roster Period.</strong>";
                
                bootbox.dialog({
                    message: message,
                    title: title,
                    buttons: {
                        cancel: {
                            label: "Close",
                            className: "btn-default",
                            callback: function () {
                            }
                        }
                    }
                });
                return; 
            }

            if(responseData.limitationReached ){
                message = message + "<strong>You have exceeded the maximum number of Requests " + 
                "(" + responseData.activeRequests + "/" + responseData.maxLimit + ")" + " for this Roster Period " +
                "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ")." + "</strong><br>";
            }
            if(responseData.isOverdue == true){
                message = message + "<strong>The Deadline to submit requests for this Roster Period " + "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ") has passed.</strong><br><br>";
            }

            if(type == "Ground Duty" && responseData.hasDailyLimitation == true){
                message = message + "<strong>The selected date " + rosterRequest.DutyDate + " has limited Availability. The probability to get your request is low.</strong><br>";
            }
            if(type == "Ground Duty" && responseData.weekendRequestsLimitReached == true ){
                message = message + "<strong>You have exceeded the allowed number of Weekends Requests for this Roster Period " +
                "(" + rosterPeriodFrom + " to " + rosterPeriodTo + ").</strong><br><br>";
            }
            message = message + " <strong>Your request will be ignored by the system. Do you want to send it for Managment Approval? </strong><br>";

            bootbox.dialog({
                message: message,
                title: title,
                buttons: {
                    confirm: {
                        label: 'Confirm',
                        className: "btn-success",
                        callback: function () {
                            submitForcedRequest(rosterRequest, type);
                        }
                    },
                    cancel: {
                        label: "Cancel",
                        className: "btn-default",
                        callback: function () { }
                    }
                }
            })
        }

        /**
         * Opens a modal with overlapping message
         * @memberof RequestsCtrl
         */
        function showOverlappingMessage(){
            var title = "<strong>Warning!</strong>";
            var message = "<strong>You cannot submit 2 requests for the same date.</strong><br>";
            bootbox.dialog({
                message: message,
                title: title,
                buttons: {
                    cancel: {
                        label: "Close",
                        className: "btn-default",
                        callback: function () { }
                    }
                }
            })
        }
        /**
         * Opens a modal with overlapping message
         * @memberof RequestsCtrl
         */
        function showPeriodNotFoundMessage(){
            var title = "<strong>Warning!</strong>";
            var message = "<strong>You cannot send request for this roster period.</strong><br>";
            bootbox.dialog({
                message: message,
                title: title,
                buttons: {
                    cancel: {
                        label: "Close",
                        className: "btn-default",
                        callback: function () { }
                    }
                }
            })
        }
        
        /**
         * Submits the forced request
         * @memberof RequestsCtrl
         */
        function submitForcedRequest(rosterRequest, type) {
  
            if (type == "Flight") {
                rosterRequest.IsForced = true;
                RequestFactory.sendFlightRequest(rosterRequest)
                    .then(response => {
                        handleSubmitResponse(response);
                    });
            }
            else if (type == "Ground Duty") {
                rosterRequest.IsForced = true;

                RequestFactory.sendGroundRequest(rosterRequest)
                    .then(response => {
                        handleSubmitResponse(response);
                    });
            }
        }

        function getRejectReason(rejectReasonId) {
            var reasonText = "";
            if(rejectReasonId && $scope.ancillaries ){
                var rejectReason = $scope.ancillaries.RejectReasons.find(f => f.Id == rejectReasonId)
                if (rejectReason) {
                    reasonText = rejectReason.Text;
                }
            }
            return reasonText;
        }

        function filterRequest(request) {
            var isShown = false;
            if (request.Id > 0) {
                if (( request.StatusText == "FinalAccepted") && $scope.toggle.FinalAccepted) {
                    isShown = true;
                } else if (((request.ValidationStatusText == "Validated" && request.StatusText != "FinalAccepted") || request.StatusText == "Accepted" || request.StatusText == "Acknowledged") && $scope.toggle.Accepted) {
                    isShown = true;
                } else if ((request.StatusText == "Pending") && $scope.toggle.Pending) {
                    isShown = true;
                } else if (request.StatusText == "Rejected" && $scope.toggle.Rejected) {
                    isShown = true;
                } 
            }
            return isShown;
        }

        function getRequestBorderStyle(request) {
            var textclass = "";
            if (request.StatusText == "FinalAccepted") {
            textclass = "border-left-green";
            } else if (request.StatusText == "Accepted") {
                textclass = "border-left-indigo";
            } else if (request.StatusText == "Pending" || request.StatusText == "Acknowledged") {
                textclass = "border-left-light-blue";
            } else if (request.StatusText == "Rejected") {
                textclass = "border-left-red";
            } else {
                textclass = "border-left-blue-gray";
            }
            return textclass;
        }



        function showHelp() {
            $uibModal.open({
                templateUrl: 'views/RosterRequests/dlgRequestInstructions.html',
                controller: 'RequestInstructionsCtrl',
                size: 'lg',
                scope: $scope,
                backdrop: 'static',
                keyboard: false,
                resolve: {}
            })
        }

        function toggleViewMode(elem, className) {
            $('body').find('div#' + elem + ' > div').not('.tip').hide("slow");
            $('body').find('div#' + elem + ' div.' + className).not('.tip').show("slow");
        }
    }
})();